module.exports = __webpack_public_path__ + "static/media/myriad.efc9813a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/myriad.ttf
// module id = 199
// module chunks = 0